module.exports = __webpack_public_path__ + "static/img/logo.080aa46c.png";